/* unplugin-vue-components disabled */import script from "./TecentMeetingCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TecentMeetingCard.vue?vue&type=script&lang=ts&setup=true"

import "./TecentMeetingCard.vue?vue&type=style&index=0&id=25cc12d3&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈尔滨医科大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25cc12d3"]])

export default __exports__